import { render, staticRenderFns } from "./ModalContentEditCommunityInfrastructure.vue?vue&type=template&id=8345f6ec&"
import script from "./ModalContentEditCommunityInfrastructure.vue?vue&type=script&lang=js&"
export * from "./ModalContentEditCommunityInfrastructure.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentEditCommunityInfrastructure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports